import React from "react";
import logoNew from "../../assets/images/logo_new.png";

const Loaders = () => {
  return (
    <section className="recruit-loader-section" id="recruit-banner">
      <div className="recruit-loader-overlay" role="status" aria-label="Loading">
        <div className="recruit-loader-spinner-wrap">
          <div className="recruit-loader-ring">
            <div className="recruit-loader-ring-inner" />
          </div>

          <div className="recruit-loader-core" />

          <img src={logoNew} alt="Loading..." className="recruit-loader-logo" />
        </div>
      </div>
    </section>
  );
};

export default Loaders;